/* @flow */

'use strict';

var getStateKey = function getStateKey(elementKey /*: ?string*/) /*: string*/ {
  return elementKey === null || elementKey === undefined ? 'main' : elementKey.toString();
};

module.exports = getStateKey;


//////////////////
// WEBPACK FOOTER
// ./~/@jimpick/spectacle/~/radium/lib/get-state-key.js
// module id = 457
// module chunks = 2